module.exports = __webpack_public_path__ + "img/avatar5.148112c6.png";